import { useState, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import ProductCard from './ProductCard';

export default function ProductGrid({ products }) {
  const [searchParams] = useSearchParams();

  const cat   = searchParams.get('cat')   || searchParams.get('category') || 'all';
  const brand = searchParams.get('brand') || 'all';

  const filtered = useMemo(() => {
    let list = [...products];
    if (cat   !== 'all') list = list.filter(p => p.category === cat);
    if (brand !== 'all') list = list.filter(p => p.brand    === brand);
    return list;
  }, [products, cat, brand]);

  return (
    <div>
      {/* ── Responsive grid styles ── */}
      <style>{`
        .product-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
          gap: 48px 24px;
        }
        @media (max-width: 768px) {
          .product-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 32px 12px;
          }
        }
      `}</style>

      {/* Grid */}
      {filtered.length === 0
        ? <div style={{
            padding: '80px 0', textAlign: 'center', fontSize: 12,
            color: 'var(--grey-mid)', letterSpacing: '0.15em', textTransform: 'uppercase'
          }}>
            No items match your selection
          </div>
        : <div className="product-grid">
            {filtered.map(p => <ProductCard key={p.id} product={p} />)}
          </div>
      }
    </div>
  );
}